import React from 'react';
import { Image } from 'semantic-ui-react'

const dialogue = (code) => [
	{text:"You did it! The moon has regained its power!"},
	{text:"In your honor, the council has decided to throw you a great Halloween party!"},
	{text:"Turns out this competition wasn't needed after all... But since we did it, we will give a reward to the winning team!"},
	{text:"Now enjoy the party!"},
	{text: "HAPPY HALLOWEEN!!!"},
	]

export default dialogue